const tabItems = [
  {
    title: "مدیریت دامنه‌ها",
    img: "/domain.svg",
    img_deactive: "/domain-d.svg",
    section_title: "مدیریت دامنه‌ها",
    caption: `به کمک DNS ابری آبالون، می‌توانید زون‌ها و رکوردهای مربوط به تعداد نامحدودی از دامنه‌های خود را به‌سادگی مدیریت کرده و آن‌ها را برای کاربران سراسر جهان در دسترس قرار دهید. بهره‌گیری از معماری Anycast موجب می‌شود درخواست‌های DNS از نزدیک‌ترین سرور پاسخ داده شوند و در نتیجه، سرعت پاسخ‌گویی و دسترسی‌پذیری به‌طور چشم‌گیری افزایش یابد.`,
    contentImg: "/ddos-c.7eebc2f 1.svg",
    link: "/vpc",
    imgAlt: "مدیریت دامنه‌ها در پنل کاربری شبکه توزیع محتوا",
    imgTitle: "مدیریت دامنه‌ها در سرویس CDN",
    contentImgAlt: "پنل کاربری مدیریت دامنه در سرویس CDN",
    contentImgTitle: "پنل کاربری مدیریت دامنه در سرویس CDN",
  },
  {
    title: "گزارش‌ها",
    img: "/report.svg",
    img_deactive: "/report-d.svg",
    section_title:
      "با سرور ابری «آبالون» کسب‌وکار خود را سریع و ساده گسترش دهید!",
    caption: `پنل مدیریتی سرویس CDN آبالون، مجموعه‌ای از گزارش‌های تحلیلی دقیق مانند میزان ترافیک، درخواست‌های صرفه‌جویی‌شده از طریق کش CDN، و آمار مربوط به دوره‌های زمانی مختلف را در اختیار شما قرار می‌دهد. همچنین امکان مشاهده و بررسی خطاهای مرتبط با رکوردهای DNS نیز فراهم است تا بتوانید به‌سرعت نسبت به رفع آن‌ها اقدام کنید.`,
    contentImg: "/report-c.11b26e7 1.svg",
    link: "/vps",
    imgAlt: "گزارش‌های سرویس CDN",
    imgTitle: "گزارش‌های سرویس CDN",
    contentImgAlt: "گزارش‌های پنل کاربری سرویس CDN",
    contentImgTitle: "گزارش‌های پنل کاربری سرویس CDN",
  },
  {
    title: "فایروال و WAF یکپارچه",
    img: "/waf.svg",
    section_title: "کد زدن و آزمون و خطا از شما، زیرساخت و پشتیبانی از ما!    ",
    img_deactive: "/waf-d.svg",
    caption:
      "در پنل مدیریتی CDN آبالون، می‌توانید قوانین فایروال را به‌صورت دستی یا خودکار تنظیم کنید و با بهره‌گیری از WAF یکپارچه و ابری، بدون نیاز به تجهیزات سخت‌افزاری، از وب‌اپلیکیشن‌های خود در برابر تهدیدات روز محافظت نمایید.",
    contentImg: "/waf-c.6f5be55 1.svg",
    link: "/paas",
    imgAlt: "فایروال و WAF یکپارچه",
    imgTitle: "فایروال و WAF یکپارچه",
    contentImgAlt: "فایروال و WAF یکپارچه",
    contentImgTitle: "فایروال و WAF یکپارچه",
  },
  {
    title: "جلوگیری از حملات DDoS",
    img: "/ddos.svg",
    section_title: "پشتیبانی مداوم، منظم و مدیریت فعال زیرساخت‌های IT شما    ",
    img_deactive: "/ddos-d.svg",
    caption:
      "در پنل کاربری CDN آبالون، امکان مدیریت تنظیمات مقابله با حملات DDoS فراهم است. می‌توانید از میان چالش‌هایی مانند CAPTCHA، جاوااسکریپت (JS Challenge) و Cookie، روش مناسب را انتخاب کنید. سامانه محافظت در برابر DDoS آبالون، انواع حملات مبتنی بر حجم، پروتکل و اپلیکیشن را پیش از رسیدن به سرورهای شما شناسایی و مسدود می‌نماید.",
    contentImg: "/ddos-c.7eebc2f 1.svg",
    link: "/manageservices",
    imgAlt: "جلوگیری از حملات دیداس با خرید CDN",
    imgTitle: "جلوگیری از حملات دیداس با خرید CDN",
    contentImgAlt: "تنظیمات جلوگیری از حملات دیداس در پنل کاربری سرویس CDN",
    contentImgTitle: "تنظیمات جلوگیری از حملات دیداس در سرویس CDN",
  },
];

const solotionTabItems = [
  {
    title: "سازمان‌های بزرگ",
    img: "/store.svg",
    imgAlt: "کاربردهای سرویس CDN برای سازمان‌های بزرگ",
    imgTitle: "کاربردهای سرویس CDN برای سازمان‌های بزرگ",
    img_deactive: "/store.svg",
    section_title: "سازمان‌های بزرگ",
    caption: `اگر به دنبال راهکاری مطمئن برای افزایش امنیت و پایداری سرویس‌های سازمان‌تان هستید، CDN آبالون گزینه‌ای حرفه‌ای برای شماست. با این سرویس می‌توانید در برابر حملات سایبری از جمله DDoS ایمن بمانید و در مواقع افزایش ناگهانی ترافیک، بدون نگرانی از کاهش عملکرد، پاسخ‌گوی کاربران‌تان باشید. همچنین با تکیه بر زیرساخت مقیاس‌پذیر آبالون، سرویس‌های شما همیشه با سرعت و آپ‌تایم بالا در دسترس خواهند بود.`,
    contentImg: "/store-c.svg",
    contentImgAlt: "کاربردهای سرویس CDN برای سازمان‌های بزرگ",
    contentImgTitle: "کاربردهای سرویس CDN برای سازمان‌های بزرگ",
    link: "/vpc",
    alt: "سرویس دیتاسنتر ابری آبالون",
    contentItem: [
      {
        name: "دسترسی همیشگی به محتوا",
        img: "/uptime.svg",
        alt: "آپ‌تایم بالای سازمان‌های بزرگ با کمک شبکه توزیع محتوا",
        title: "آپ‌تایم بالای وب‌سایت با خرید CDN",
      },
      {
        name: "مقابله با حملات پیشرفته DDoS",
        img: "/atactks.svg",
        alt: "مقابله با حملات پیشرفته DDoS با کمک شبکه توزیع محتوا",
        title: "مقابله با حملات پیشرفته DDoS با خرید CDN",
      },
      {
        name: "مدیریت تعداد نامحدود دامنه‌ها",
        img: "/customer.svg",
        alt: "مدیریت تعداد نامحدود دامنه‌ها با خرید CDN",
        title: "مدیریت تعداد نامحدود دامنه‌ها با خرید CDN",
      },
      {
        name: "افزایش سرعت دسترسی به سرویس‌ها",
        img: "/geography.svg",
        alt: "افزایش سرعت دسترسی به سرویس‌ها با خرید CDN",
        title: "سرعت دسترسی به سرویس‌ها با خرید CDN",
      },
    ],
  },
  {
    title: "فروشگاه‌های آنلاین",
    img: "/startup.svg",
    imgAlt: "کاربردهای سرویس CDN برای فروشگاه‌های آنلاین",
    imgTitle: "کاربردهای سرویس CDN برای فروشگاه‌های آنلاین",
    img_deactive: "/startup.svg",
    section_title: "فروشگاه‌های آنلاین",
    caption: `اگر صاحب یک فروشگاه اینترنتی هستید، CDN آبالون با تحویل سریع محتوا، حفظ آپ‌تایم بالا و مقابله با حملات سایبری، تجربه‌ای پایدار و ایمن برای کاربران شما فراهم می‌کند. این سرویس با پشتیبانی از توزیع بار ترافیکی در رویدادهای پرترافیک مانند جشن‌ها و تخفیف‌ها، عملکرد فروشگاه را حفظ کرده و به بهبود رتبه SEO و افزایش نرخ تبدیل مشتریان کمک می‌کند.`,
    contentImg: "/startup-c.svg",
    contentImgAlt: "کاربردهای سرویس CDN برای فروشگاه‌های آنلاین",
    contentImgTitle: "کاربردهای سرویس CDN برای فروشگاه‌های آنلاین",
    link: "/vps",
    alt: "سرویس سرور ابری آبالون",
    contentItem: [
      {
        name: " آپ‌تایم بالا",
        img: "/ssl.svg",
        alt: "آپ‌تایم بالا با خرید شبکه توزیع محتوا",
        title: "آپ‌تایم بالا با خرید CDN",
      },
      {
        name: "مقابله با حملات سایبری پیشرفته",
        img: "/cms.svg",
        alt: "مقابله با حملات سایبری پیشرفته",
        title: "مقابله با حملات سایبری پیشرفته",
      },
      {
        name: "توزیع بار ترافیکی در مناطق جغرافیایی",
        img: "/seo.svg",
        alt: "توزیع بار ترافیکی در مناطق جغرافیایی",
        title: "توزیع بار ترافیکی در مناطق جغرافیایی",
      },
      {
        name: "افزایش نرخ تبدیل مشتریان",
        img: "/price.svg",
        alt: "افزایش نرخ تبدیل مشتریان با کمک شبکه توزیع محتوا",
        title: "افزایش نرخ تبدیل مشتریان با کمک سرویس CDN",
      },
    ],
  },
  {
    title: "کسب‌و‌کارهای کوچک و استارت‌آپ‌ها",
    img: "/company.svg",
    imgAlt: "کاربردهای سرویس CDN برای کسب‌و‌کارهای کوچک و استارت‌آپ‌ها",
    imgTitle: "کاربردهای سرویس CDN برای کسب‌و‌کارهای کوچک و استارت‌آپ‌ها",
    section_title: "کد زدن و آزمون و خطا از شما، زیرساخت و پشتیبانی از ما!",
    img_deactive: "/company.svg",
    caption: `اگر صاحب یک استارت‌آپ یا کسب‌وکار کوچک هستید، با استفاده از CDN آبالون می‌توانید امنیت وب‌سایت خود را افزایش دهید، سئوی بهتری داشته باشید و تجربه‌ای سریع‌تر و پایدارتر به کاربران ارائه کنید. این سرویس با تحویل محتوا از پاپ‌سایت‌های داخلی و بین‌المللی، میزان مصرف پهنای باند سرور مبدأ را کاهش می‌دهد و به صرفه‌جویی در هزینه‌ها کمک می‌کند. `,
    contentImg: "/company-c.svg",
    contentImgAlt: "کاربردهای سرویس CDN برای کسب‌و‌کارهای کوچک و استارت‌آپ‌ها",
    contentImgTitle:
      "کاربردهای سرویس CDN برای کسب‌و‌کارهای کوچک و استارت‌آپ‌ها",
    link: "/paas",
    alt: "سرویس پلتفرم ابری آبالون",
    contentItem: [
      {
        name: " گواهینامه SSL رایگان",
        img: "/access.svg",
        alt: "گواهینامه SSL رایگان با خرید CDN",
        title: "گواهینامه SSL رایگان با خرید CDN",
      },
      {
        name: "بهبود SEO وب‌سایت",
        img: "/ddosAtacks.svg",
        alt: "بهبود SEO وب‌سایت با خرید CDN",
        title: "بهبود SEO وب‌سایت با خرید CDN",
      },
      {
        name: "پشتیبانی از CMSها",
        img: "/domainss.svg",
        alt: "پشتیبانی از CMSها در شبکه توزیع محتوا",
        title: "پشتیبانی از CMSها در سرویس CDN",
      },
      {
        name: "کاهش هزینه پهنای باند مصرفی",
        img: "/speed.svg",
        alt: "کاهش هزینه پهنای باند مصرفی با خرید CDN",
        title: "کاهش هزینه پهنای باند مصرفی با خرید CDN",
      },
    ],
  },
];

const logos = [
  {
    url: "/images/new_customers/amirkabir.png",
    name: "دانشگاه صنعتی امیرکبیر",
  },
  {
    url: "/images/new_customers/azad.png",
    name: "دانشگاه آزاد اسلامی",
  },
  {
    url: "/images/new_customers/bankrefah.png",
    name: "بانک رفاه کارگران",
  },
  {
    url: "/images/new_customers/bankshahr.png",
    name: "بانک شهر",
  },
  {
    url: "/images/new_customers/barkat.png",
    name: "شرکت کارگزاری بیمه برکت",
  },
  {
    url: "/images/new_customers/bidbarg.png",
    name: "بیدبرگ",
  },
  {
    url: "/images/new_customers/digikala.png",
    name: "دیجی کالا",
  },
  {
    url: "/images/new_customers/eastcool.png",
    name: "ایستکول",
  },
  {
    url: "/images/new_customers/elmosanat.png",
    name: "دانشگاه علم و صنعت",
  },
  {
    url: "/images/new_customers/freezone.png",
    name: "دبیرخانه شورای عالی مناطق آزاد تجاری، صنعتی و ویژه اقتصادی",
  },
  {
    url: "/images/new_customers/HiMart.png",
    name: "هایمارت",
  },
  {
    url: "/images/new_customers/irisaco.png",
    name: "شرکت بین‌المللی مهندسی سیستم‌ها و اتوماسیون ها",
  },
  {
    url: "/images/new_customers/jameazad.png",
    name: "جامعه آزاد رایانش ابری ایران",
  },
  {
    url: "/images/new_customers/javid.png",
    name: "گروه جاوید",
  },
  {
    url: "/images/new_customers/khandevane.png",
    name: "خندوانه",
  },
  {
    url: "/images/new_customers/madiran.png",
    name: "مادیران",
  },
  {
    url: "/images/new_customers/mahran.png",
    name: "مهرام",
  },
  {
    url: "/images/new_customers/mashal.png",
    name: "مشعل",
  },
  {
    url: "/images/new_customers/meydon.png",
    name: "میدون",
  },
  {
    url: "/images/new_customers/mofid.png",
    name: "کارگزاری مفید",
  },
  {
    url: "/images/new_customers/netbarg.png",
    name: "نت‌برگ",
  },
  {
    url: "/images/new_customers/parskhazar.png",
    name: "پارس خزر",
  },
  {
    url: "/images/new_customers/parsonline.png",
    name: "پارس آنلاین",
  },
  {
    url: "/images/new_customers/pegah.png",
    name: "پگاه",
  },
  {
    url: "/images/new_customers/pejoheshgah.png",
    name: "پژوهشگاه هواشناسی",
  },
  {
    url: "/images/new_customers/samseir.png",
    name: "سام‌سیر",
  },
  {
    url: "/images/new_customers/tanzim.png",
    name: "سازمان تنظیم مقررات رسانه های صوت و تصویر ساترا",
  },
];

const customers = [
  {
    name: "mali",
    title: "خدمات مالی و بیمه",
    children: [
      {
        name: "dey",
        title: "بیمه دی",
        banner: "/HomePage-insurance.webp",
        logo: "/dey.png",
        description: `شرکت بیمه «دی» یکی از مجموعه‌های بیمه‌ای‌ست که به تحول دیجیتال و استفاده از تکنولوژی در صنعت بیمه اهمیت زیادی می‌دهد. کارشناسان فنی این مجموعه به قابلیت افزایش و کاهش منابع در لحظه و کنترل و بهینه‌سازی هزینه‌های IT فکر می‌کردند و تمایل داشتند وارد بازی سخت و پیچیده خرید و نگه‌داری دیتاسنترهای سنتی با دغدغه‌های تمام نشدنی‌اش نشوند و اینجا آغاز همکاری و همراهی بیمه «دی» و ابر «آبالون» برای راه‌اندازی سرویس ویژه «دیتاسنتر ابری» بود که نتیجه آن بهبود فرآیندهای IT و افزایش بهره‌وری این شرکت بود!`,
        banner_alt: "نظر شرکت خدمات مالی درباره آبالون",
        logo_alt: "",
      },
    ],
  },
  {
    name: "inno&tech",
    title: "نوآوری و تکنولوژی",
    children: [
      {
        name: "diginext",
        title: "دیجی‌نکست",
        banner: "/HomePage-innovation.webp",
        logo: "/diginext.png",
        description: `دیجی‌نکست مرکز نوآوری و سرمایه‌گذاری گروه دیجی‌کالاست که به عنوان یک شتاب‌دهنده بزرگ به استارتاپ‌های زیادی برای خلق داستان موفقیت کمک می‌کند، «سرور ابری» و «دیتاسنتر ابری» دو محصول اختصاصی حوزه کلود توسط «آبالون» برای این مجموعه اجرا و پیاده‌سازی شد تا در لحظه بتواند با توجه به ویژگی مقیاس‌پذیری و انعطاف در افزایش و کاهش منابع، زیرساخت‌های مورد نیاز استارتاپ‌های خود را به آسانی از طریق داشبورد ابری «آبالون» مدیریت و بهینه کند.`,
        banner_alt: "نظر شرکت‌های نوآوری و تکنولوژی درباره آبالون",
        logo_alt: "",
      },
    ],
  },
  {
    name: "lms",
    title: "پلتفرم آموزش آنلاین",
    children: [
      {
        name: "e-seminar",
        title: "ایسمینار",
        banner: "/HomePage-elearning.webp",
        logo: "/esiminar.png",
        description: `قطعا یکی از اسامی نام‌آشنا برای ویدئوهای آموزشی و تعاملی و برگزاری وبینار در ایران، مجموعه «ایسمینار» است. حجم بسیار زیاد ویدئوها، سرعت آپلود و دانلود، اهمیت دسترس‌پذیری کاربران به محتواهای ویدئویی و قدرت پردازش بالا تنها بخشی از دغدغه‌ها و مسائل این مجموعه در زمان انتخاب ابر «آبالون» به عنوان اپراتور ابری بود که با خرید سرویس «دیتاسنتر» ابری «آبالون»، توانست به قسمت مهمی از چالش‌های زیرساختی خود پاسخی شایسته دهد.        `,
        banner_alt: "نظر پلتفرم‌های آموزش آنلاین درباره آبالون",
        logo_alt: "",
      },
    ],
  },
  {
    name: "unis",
    title: "دانشگاه‌ها و مراکز آموزشی",
    children: [
      {
        name: "aiu",
        title: "دانشگاه آزاد اسلامی",
        banner: "/HomePage-universities.webp",
        logo: "/Azad.png",
        description: `برای مجموعه‌هایی که به دلیل استراتژی‌ها و نیازهای کسب‌وکاری خود در برهه‌هایی از زمان و به صورت موردی نیاز به منابع زیاد و زیرساخت‌های موقتی دارند، دانشگاه آزاد یک نمونه بارز است که به دلیل افزایش مقطعی بار ترافیکی وب‌سایت خود برای برگزاری آزمون …. نیاز به افزایش منابع خود را با همراهی ابر «آبالون» و از طریق سرویس «دیتاسنتر ابری» به راحتی پوشش داد.`,
        banner_alt: "نظر دانشگاه‌ها و مراکز آموزشی درباره آبالون",
        logo_alt: "",
      },
    ],
  },
  {
    name: "foods",
    title: "صنایع غذایی",
    children: [
      {
        name: "pegah",
        title: "شرکت صنایع شیر ایران (پگاه)",
        banner: "/HomePage-foods.webp",
        logo: "/pegah.png",
        description: `چه کسی در ایران هست که نام پگاه را نشنیده باشد و از وسعت تولیدات و گستردگی آن بی‌خبر باشد. طبیعتاً این حجم از ارائه خدمات و محصولات با تعداد زیادی نیروی کار و فرآیندهای داخلی پیچیده و عظیم اتفاق می‌‌افتد. یک تصمیم استراتژیک در بخش IT پگاه استفاده از سرورها و «دیتاسنتر ابری» به جای خرید، راه‌اندازی و نگهداری زیرساخت‌های سنتی به صورت جداگانه برای نمایندگی‌ها و شرکت‌های زیرمجموعه‌اش در هر استان کشور بود که این ماموریت به ابر «آبالون» واگذار شد تا با ارائه سرویس‌های ابری ویژه، مدیریت میل‌سرورها، اتوماسیون‌ها و فرآیند IT داخلی این مجموعه را روی زیرساخت یکپارچه و امن ابری ارائه دهد.`,
        banner_alt: "نظر صنایع غذایی درباره آبالون",
        logo_alt: "",
      },
    ],
  },
  {
    name: "tolidis",
    title: "شرکت‌های تولیدی",
    children: [
      {
        name: "istcoll",
        title: "ایستکول",
        banner: "/HomePage-manufacturing-firms.webp",
        logo: "/istcoll.png",
        description: `شرکت با سابقه «تکران مبرد» که با نام تجاری «ایستکول» از سال 1356 تا به حال، فعالیتش در رسته لوازم خانگی و تولید انواع یخچال و… است، جلوتر از بسیاری از رقبای خودش را در این صنعت توانست با روند پیشرفت فناوری همگام شود و لزوم استفاده از سرویس‌های ابری را بپذیرد، این مجموعه نیز با اعتماد به ابر «آبالون»، درایوهای سازمانی خودش را به فضای ابری آورد و محافظت و پشتیبان‌گیری از اطلاعات خود را به دستان ابر «آبالون» سپرد.        `,
        banner_alt: "نظر شرکت‌های تولیدی درباره آبالون",
        logo_alt: "",
      },
    ],
  },
  {
    name: "banks",
    title: "بانک‌ها و موسسات مالی",
    children: [
      {
        name: "shahr",
        title: "گروه مالی شهر",
        banner: "/HomePage-banks.webp",
        logo: "/shahr.png",
        description: `هلدینگ «گروه مالی شهر» که به عنوان بازوی نیرومند «بانک شهر» شناخته می‌شود در حوزه خدمات مالی، سرمایه‌گذاری و شتاب‌دهی کسب‌و‌کارهای نوپا فعالیت می‌کند، این هلدینگ توانست برنامه استراتژیک فناوری اطلاعات خودش را همپای تکنولوژی ببیند و پا به جهان بی‌انتهای ابرها بگذارد!
          «دیتاسنتر ابری» یکی از سرویس‌های ویژه‌ای بود که به میزبانی ابر «آبالون» برای این مجموعه بزرگ راه‌اندازی و اجرا شد تا هلدینگ «گروه مالی شهر»، انعطاف‌پذیری، انطباق، قدرت پردازش و امنیت را در قلب مسیر توسعه خدمات خود تجربه کند.       `,
        banner_alt: "نظر بانک‌ها و موسسات مالی درباره آبالون",
        logo_alt: "",
      },
      {
        name: "refah",
        title: "بانک رفاه کارگران",
        banner: "/HomePage-banks.webp",
        logo: "/refah.png",
        description: `استفاده از پتانسیل بالای رایانش ابری برای هر بانک و مجموعه‌ای که در حوزه مالی و سرمایه‌گذاری فعالیت می‌کند کمتر از رقم خوردن یک معجزه در نحوه سرویس‌دهی به مشتریان و مدیریت بهینه منابع نیست! بانک رفاه کارگران نیز با بینشی مدرن، فضای توسعه زیرساخت‌ها و منابع IT خود روی «ابر» را وسیع دید و به سرویس‌های ابری خوش‌آمد گفت. ابر «آبالون» افتخار همراهی با بانک رفاه را برای پیاده‌سازی سرورهای ابری به عهده داشته و از جمله خدماتی که با استفاده از راهکارهای ابری «آبالون» به نمایش گذاشته شد، عرضه اولیه سهام در بورس توسط بانک رفاه بود.`,
        banner_alt: "نظر بانک‌ها و موسسات مالی درباره آبالون",
        logo_alt: "",
      },
      // {
      //   name: "etebar-it",
      //   title: "اعتبار آی‌تی",
      //   banner: "/banks.jpg",
      //   logo: "",
      //   description:`مجموعه صنعتی گروه «مپنا» یکی از بزرگترین مجریان و پیمانکاران عمرانی، نیروگاهی، پزشکی و… در کشور است. با توجه به وسعت فعالیت‌ها و حجم پروژه‌های مپنا، قاعدتاً این مجموعه با چالش‌های بسیاری در دپارتمان فناوری اطلاعات خود از جمله پراکندگی تمرکز مواجه است که راهکارهای ابری می‌تواند به تنهایی پاسخی درخور به موانع استفاده از زیرساخت‌های سنتی‌اش باشد. محصول ویژه «سرویس‌های مدیریت شده» و راه‌حل‌های ابری «آبالون» توانسته است جای خود را در پی‌ریزی تصمیمات تجاری و بخش IT این مجموعه باز کند تا فرآیندهای انطباق، انعطاف‌پذیری و مقیاس‌پذیری منابع IT دیگر برای‌شان دغدغه‌ای نباشد.        `
      // },
    ],
  },
  {
    name: "it",
    title: "فناوری اطلاعات",
    children: [
      {
        name: "parsOnline",
        title: "پارس آنلاین",
        banner: "/HomePage-IT.webp",
        logo: "/pars.png",
        description: `«ابر اختصاصی» نام یکی از پیچیده‌ترین و بزرگترین محصولات در بین سرویس‌های ابری‌ست که گروه شرکت‌های «پارس‌آنلاین» میزبانی این خدمت خاص را به ابر «آبالون» واگذار کرد. این مجموعه که خودش نیز یکی از قدرتمندترین ارائه‌دهندگان زیرساخت‌های فناوری اطلاعات در کشور است با دریافت خدمت ویژه راه‌اندازی ابر خصوصی به وسیله ابر «آبالون»، این امکان را دارد که خودش به میزان نامحدودی سرور ابری با منابع مدیریت شده توسط داشبورد ابری «آبالون» را به کاربرانش ارائه دهد. تیم «عملیات خلاق آبالون» در این پروژه خاص تمامی موارد طراحی و اجرایی فنی از جمله استقرار سیستم یکپارچه OSS و BSS را به عهده داشته است.        `,
        banner_alt: "نظر شرکت‌های فناوری اطلاعات درباره آبالون",
        logo_alt: "",
      },
      {
        name: "irisa",
        title: "ایریسا",
        banner: "/HomePage-IT.webp",
        logo: "/irisa.png",
        description:
          "شرکت بین‌المللی مهندسی سیستم‌ها و اتوماسیون با نام تجاری «ایریسا» که پیمانکار IT مجموعه‌های بزرگی از جمله: فولاد مبارکه اصفهان، مخابرات کل کشور، ذوب‌آهن اصفهان، بانک کشاورزی، شرکت پاکسان، شرکت ملی حفاری ایران و… است، مسئولیت تأمین زیرساخت‌های فناوری اطلاعات مشتریانش را به عهده دارد که به علت موانع رایج خریداری، راه‌اندازی، نگهداری، مقایس‌پذیری و توسعه در زیرساخت‌های سنتی IT، تصمیم به استفاده از زیرساخت‌های ابری «آبالون» را عملیاتی کرد و در حال حاضر با استفاده از پنل مدیریت منابع ابری «آبالون» می‌تواند در هر زمانی با توجه به نیاز کاربرانش افزایش یا کاهش منابع را خودش مدیریت کرده و چالش‌های مواجه با زیرساخت‌های سنتی را از فرآیندهای کاری خود حذف کند.        ",
        banner_alt: "نظر شرکت‌های فناوری اطلاعات درباره آبالون",
        logo_alt: "",
      },
    ],
  },
  {
    name: "medias",
    title: "رسانه‌ها",
    children: [
      {
        name: "khandevaneh",
        title: "خندوانه",
        banner: "/HomePage-media.webp",
        logo: "/khandevaneh.png",
        description: `مسابقه‌ای که روی ابرها برگزار شد!
          برنامه خندوانه در جریان برگزاری مسابقات استندآپ‌کمدی «خنداننده شو» نیاز به فرآیند رأی‌گیری از تماشاگرهایش داشت که طبیعتاً این ریسک محتمل بود تا در صورت استفاده از زیرساخت‌های سنتی خودش توانایی پاسخ‌دهی به حجم بالای ترافیک کاربرها را نداشته باشد و «سرور ابری» مطمئن‌ترین و بهترین راهکاری بود که به میزبانی ابر «آبالون» برای آن‌ها برنامه‌ریزی و راه‌اندازی شد تا بدون کوچکترین دغدغه‌ای پذیرای هر سطحی از استقبال کاربرهای‌شان باشند.`,
        banner_alt: "نظر رسانه‌ها درباره آبالون",
        logo_alt: "",
      },
    ],
  },
  {
    name: "agancies",
    title: "آژانس‌های خدماتی",
    children: [
      {
        name: "samsir",
        title: "سام‌سیر",
        banner: "/HomePage-agencies.webp",
        logo: "/Samseir.png",
        description: `آژانس هواپیمایی «سام‌ سِیر» که سامانه‌ای برای خرید آنلاین بلیط هواپیماست، مثل تمام فعالان این حوزه، کاملاً با چشم‌انداز زیبای روی ابرها آشنا بود تا اینکه برای توسعه زیرساخت‌های سنتی خودش نیز دست به اقدام هوشمندانه‌ای زد و آن‌ها را هم روی ابرها آورد!
          زیرساخت‌های ابری «آبالون» مسیر توسعه خدمات را برای این مجموعه کاملا هموار کرده و با مدیریت یکپارچه منابع ابری سام سیر، توانسته‌ایم فضای سرویس‌دهی آن‌ها را مجهز به قابلیت‌های «رایانش ابری» کنیم!`,
        banner_alt: "نظر آژانس‌های خدماتی درباره آبالون",
        logo_alt: "",
      },
    ],
  },
  {
    name: "indus-orgs",
    title: "سازمان‌های صنعتی",
    children: [
      {
        name: "mapna",
        title: "مپنا",
        banner: "/HomePage-industries.webp",
        logo: "/Mapna.png",
        description: `مجموعه صنعتی گروه «مپنا» یکی از بزرگترین مجریان و پیمانکاران عمرانی، نیروگاهی، پزشکی و… در کشور است. با توجه به وسعت فعالیت‌ها و حجم پروژه‌های مپنا، قاعدتاً این مجموعه با چالش‌های بسیاری در دپارتمان فناوری اطلاعات خود از جمله پراکندگی تمرکز مواجه است که راهکارهای ابری می‌تواند به تنهایی پاسخی درخور به موانع استفاده از زیرساخت‌های سنتی‌اش باشد. محصول ویژه «سرویس‌های مدیریت شده» و راه‌حل‌های ابری «آبالون» توانسته است جای خود را در پی‌ریزی تصمیمات تجاری و بخش IT این مجموعه باز کند تا فرآیندهای انطباق، انعطاف‌پذیری و مقیاس‌پذیری منابع IT دیگر برای‌شان دغدغه‌ای نباشد.        `,
        banner_alt: "نظر آژانس‌های خدماتی درباره آبالون",
        logo_alt: "",
      },
    ],
  },
];

const dataBlog = [
  {
    img: "SLA.webp",
    link: "https://abalon.cloud/blog/sla/",
    type: "دسترسی سریع",
    title: "راهنمای سطوح ارائه خدمات ",
    desc: "کلیه مشتریان (حقیقی و حقوقی) آبالون، می‌‌بایست از «شرایط و ضوابط استفاده از خدمات ابری» اطلاع داشته و شرایط مذکور را به ‌طور کامل مورد قبول و پذیرش خود قرار دهند. شرایط استفاده از خدمات در آبالون مبتنی بر قوانین جمهوری اسلامی ایران می‌باشد",
    alt: "راهنمای سطوح ارائه خدمات آبالون",
  },
  {
    img: "Post-2.webp",
    link: "https://www.instagram.com/p/CgZvI1gjfV6/?igshid=MDJmNzVkMjY%3D",
    type: "اینستاگرام",
    title: "معرفی اپلیکشن‌های کاربردی - قسمت دوم",
    desc: "همه می دانیم که سهم گوشی های هوشمند، کامپیوترها و اینترنت در ساعات یک روز ما چقدر تعیین کننده است. با استفاده بهینه‌تر از این ابزارهای هوشمند، می‌توانیم اثربخشی بهتری را در عادت‌های خود و زمانی که برایشان می‌گذاریم تجربه کنیم.",
    alt: "معرفی اپلیکیشن‌های کاربردی آبالون",
  },

  {
    img: "VPSvsVDS.webp",
    link: "https://abalon.cloud/blog/%d8%aa%d9%81%d8%a7%d9%88%d8%aa-vps-%d9%88-vds/",
    type: "وبلاگ",
    title: "تفاوت VPS و VDS",
    desc: "صاحبان کسب‌وکارها همیشه به دنبال راهی برای افزایش زیرساخت و بستر مناسب برای گسترش خدمات و مشتریان خود هستند. یکی از کلیدی ترین زیرساخت های لازم، زیرساخت های فنی هستند. البته تامین این زیرساخت‌ها برای بسیاری از کسب‌وکارها به صرفه نبوده و گزینه استفاده از خدمات شرکت های ارائه دهنده خدمات ابری به وجود می‌آید. جایی که کسب‌وکارها را نیازمند می‌کند تا تفاوت VPS و VDS را به طور کامل بدانند.",
    alt: "تفاوت VPS و VDS آبالون",
  },
  {
    img: "Post-3.webp",
    link: "https://www.instagram.com/p/Cd3gU0ANXj1/?igshid=MDJmNzVkMjY=",
    type: "اینستاگرام",
    title: "دانستنی‌های کلود",
    desc: "رایانش ابر درباره نحوه انجام پردازش هاست، نه جایی که پردازش انجام می‌دهید». شاید مهم‌ترین مزیت استفاده از تکنولوژی ابری، عدم نیاز به حضور در مکانی خاص یا استفاده از ابزارهایی مشخص برای برقراری ارتباطات باشد.",
    alt: "دانستنی‌های کلود آبالون",
  },
  {
    img: "server-response-time.webp",
    link: "https://abalon.cloud/blog/%da%a9%d8%a7%d9%87%d8%b4-%d8%b2%d9%85%d8%a7%d9%86-%d9%be%d8%a7%d8%b3%d8%ae%da%af%d9%88%db%8c%db%8c-%d8%b3%d8%b1%d9%88%d8%b1/",
    type: "وبلاگ",
    title: "کاهش زمان پاسخگویی سرور",
    desc: "یکی از عواملی که بر تجربه کاربر از مراجعه به سایت تاثیرگذار است، مدت زمان بارگذاری سایت و پاسخ سرور است. با توجه به اینکه افراد برای انجام تمام امور روزمره خود از روش‌های آنلاین استفاده می‌کنند، عاملی که می‌تواند در این بازار مزیت اصلی برای رقابت محسوب شود، سرعت پاسخ‌دهی بالای یک سایت است. آبالون در این مقاله سعی دارد عواملی که بر سرعت سایت تاثیرگذار هستند و راه‌های کاهش زمان پاسخگویی سرور را اطلاع دهد.",
    alt: "کاهش زمان پاسخگویی سرور آبالون",
  },
  {
    img: "Post-1.webp",
    link: "https://www.instagram.com/p/ChPvZ5ijiXh/?igshid=MDJmNzVkMjY%3D",
    type: "اینستاگرام",
    title: "معرفی بهترین دوره‌های آنلاین",
    desc: "با توجه به نتایج جستجو در گوگل، تصمیم‌گیری در مورد یک دوره خاص کار سختی است. اگر مایل به یادگیری کلود هستید و به تازگی «رایانش ابری» را در گوگل جستجو کرده‌اید از دیدن تعداد زیادی موسسه آموزشی که دوره‌هایی در این زمنه ارائه میددهند غافلگیر خواهید شد.",
    alt: "معرفی بهترین دوره‌های آنلاین آبالون",
  },
  {
    img: "Cloud-Database.webp",
    link: "https://abalon.cloud/blog/%d8%af%db%8c%d8%aa%d8%a7%d8%a8%db%8c%d8%b3-%d8%a7%d8%a8%d8%b1%db%8c-%da%86%db%8c%d8%b3%d8%aa-%d9%88-%da%86%d9%87-%da%a9%d8%a7%d8%b1%d8%a8%d8%b1%d8%af%db%8c-%d8%af%d8%a7%d8%b1%d8%af/",
    type: "وبلاگ",
    title: "دیتابیس ابری چیست و چه کاربردی دارد",
    desc: "در سال‌های گذشته تکنولوژی ابری با استقبال بسیار زیادی مواجه شده‌است و از آن در زمینه‌های مختلف ایجاد سرور، گیمینگ و اجرای نرم افزارهای مختلف استفاده می‌شود. یکی از نمونه‌های استفاده از یارانش ابری، دیتابیس ابری است. در این مقاله به صورت ساده دیتاسنتر ابری را توضیح داده‌ایم و مزیت‌ها و چالش‌های آن را بیان کرده‌ایم. با ما همراه باشید.",
    alt: "دیتابیس ابری آبالون",
  },
  {
    img: "Help.webp",
    link: "https://abalon.cloud/blog/help/",
    type: "دسترسی سریع",
    title: "راهنمای محصولات ",
    desc: "با استفاده از راهنمای محصولات می توانید به راحتی شروع به استفاده از محصولات آبالون نمایید و اگر در حین استفاده از خدمات آبالون، سوالی داشتید به راحتی سوال خود را برطرف کنید.",
    alt: "راهنمای محصولات آبالون",
  },
];

const questions = [
  {
    title: "خرید CDN ایرانی آبالون چه مزیتی نسبت به CDN های خارجی دارد؟",
    answer:
      "سرویس CDN آبالون با بیش از ۴۰ پاپ‌سایت ایرانی و بین‌المللی، زیرساخت توزیع محتوای گسترده‌ای در داخل ایران فراهم کرده است. خرید CDN آبالون، باعث کاهش چشمگیر تأخیر برای کاربران داخل کشور و ارائه تجربه‌ای سریع‌تر و پایدارتر نسبت به سرویس‌های خارجی فاقد پاپ‌سایت داخلی می‌شود.",
  },
  {
    title: "آیا سرویس CDN آبالون باعث افزایش امنیت وب‌سایت من می‌شود؟",
    answer:
      "بله. آبالون با بهره‌گیری از لایه‌های امنیتی مختلف مانند WAF، فایروال، چالش‌های امنیتی لایه ۷، محدودسازی نرخ درخواست‌ها و مقابله با حملات DDoS در لایه‌های مختلف، امنیت وب‌سایت یا اپلیکیشن شما را به‌صورت جامع و یکپارچه تأمین می‌کند.",
  },
  {
    title:
      "آیا در سرویس CDN آبالون می‌توان بار را میان چند سرور توزیع کرد و این کار پیچیدگی خاصی دارد؟",
    answer:
      "بله. با استفاده از لود بالانسرهای DNS و HTTP آبالون، می‌توانید بدون نیاز به زیرساخت اختصاصی و تنظیمات پیچیده، ترافیک را به‌صورت پیشرفته مدیریت و میان چند سرور توزیع کنید. این ابزارها با رابط کاربری ساده، امکان راه‌اندازی سریع و پایدار را فراهم می‌کنند.",
  },
  {
    title: "گواهینامه SSL در CDN آبالون چگونه فعال می‌شود؟",
    answer:
      "CDN آبالون برای تمام دامنه‌های متصل، به‌صورت خودکار گواهینامه SSL رایگان صادر و فعال می‌کند. این فرآیند بدون نیاز به مداخله شما انجام شده و ارتباط امن HTTPS را برای کاربران نهایی تضمین می‌کند. البته در صورت تمایل، می‌توانید گواهینامه SSL اختصاصی خود را نیز بارگذاری و استفاده کنید.",
  },
  {
    title: "برای انتخاب بهترین CDN ایرانی چه فاکتورهایی باید مدنظر گرفت؟",
    answer:
      "در انتخاب یک CDN ایرانی قدرتمند، فاکتورهایی مانند وجود پاپ‌سایت‌های توزیع‌شده در داخل کشور و نقاط کلیدی جهان، امکانات امنیتی پیشرفته نظیر WAF، فایروال و جلوگیری از حملات DDoS، و همچنین قابلیت لود بالانسینگ برای مدیریت بهینه ترافیک اهمیت دارد. در کنار این ویژگی‌های فنی، یک CDN حرفه‌ای باید رابط کاربری ساده و در عین حال امکان پیکربندی پیشرفته را نیز در اختیار کاربران قرار دهد. CDN ایرانی آبالون با ترکیب این قابلیت‌ها، یکی از گزینه‌های برتر برای سازمان‌ها و کسب‌وکارهای ایرانی است.",
  },
];

const cdnCoverage = [
  {
    title: "99.9٪",
    cap: "آپ‌تایم تضمین شده سرویس CDN",
  },
  {
    title: "500 میلیون",
    cap: "ظرفیت پاسخ به درخواست‌ها در هر ساعت",
  },
  {
    title: "2 ترابیت بر ثانیه",
    cap: "ظرفیت مقابله با حملات سایبری",
  },
  {
    title: "40+",
    cap: "پاپ‌سایت در ۵ قاره جهان",
  },
];

const PopularServices = [
  {
    title: "دیتاسنتر ابری",
    desc: "دیتاسنتر ابری تمامی قابلیت‌های یک دیتاسنتر فیزیکی را روی ابر برایتان فراهم می‌کند و می‌تواند پاسخی برای پیچیده‌ترین و تخصصی‌ترین نیازهای ابری شما باشد. ",
    logo: "VPC-Service.svg",
    route: "/vpc",
    imgAlt: "دیتاسنتر ابری آبالون",
    imgTitle: "دیتاسنتر ابری آبالون",
  },
  {
    title: "PAM ابری آبالون",
    desc: "با راهکار PAM ابری، دسترسی به محیط سیستم‌عامل‌های متنوع و هر نرم‌افزار سازمانی را در اختیار کاربران خود بگذارید و با نظارت و تعیین سطوح دسترسی، همه فعالیت‌های آنها را نگهداری کنید.",
    logo: "VPS-Service.svg",
    route: "/pam",
    imgAlt: "خرید سرویس PAM آبالون",
    imgTitle: "خرید سرویس PAM آبالون",
  },
  {
    title: "ابر ایزوله آبالون",
    desc: "با سرویس ابر ایزوله آبالون از زیرساخت سازمان خود، بر بستر امن و ایزوله از اینترنتِ نورونتا، به منابع نامحدود ابری آبالون متصل شوید. گویی اینکه همه تجهیزات، یکجا و در سازمان شما مستقر شده‌اند.",
    logo: "CloudGuard-Service.svg",
    route: "/isolated-cloud",
    imgAlt: "سرویس ابر ایزوله آبالون",
    imgTitle: "سرویس ابر ایزوله آبالون",
  },
  {
    title: "خدمات دواپس",
    desc: "بدون نیاز به استخدام نیروی داخلی، با تکیه بر تجربه مهندسان DevOps آبالون، زیرساختی پایدار، امن و منطبق با الزامات قانونی و استانداردهای نهادهای بالادستی برای سازمان خود ایجاد کنید.",
    logo: "ManagedService-Service.svg",
    route: "/devops",
    imgAlt: "خدمات دواپس آبالون",
    imgTitle: "خدمات دواپس آبالون",
  },
];

const scrubbingCenter = [
  {
    title: "فایروال",
    specialChar: "(L3/L4)",
    desc: "جلوگیری از حملات لایه‌های ۳ و ۴ مانند UDP Flood ،SYN Flood و Smurf با فیلتراسیون پیشرفته بر اساس IP، کشور و پروتکل",
  },
  {
    title: "فایروال وب اپلیکیشن (WAF)",
    specialChar: "",
    desc: "محافظت از وب‌سایت‌ها در برابر تهدیدات لایه ۷ مانند SQL Injection ،XSS، و HTTP Flood با بروزرسانی خودکار قوانین امنیتی",
  },
  {
    title: "محدودیت نرخ درخواست (Rate Limiting)",
    specialChar: "",
    desc: "مدیریت دقیق جریان ترافیک با تعریف نرخ مجاز درخواست برای هر مسیر یا سرویس، جهت مقابله با سوءاستفاده‌های اپلیکیشنی",
  },
  {
    title: "چالش‌های امنیتی پیشرفته (DDoS Challenges)",
    specialChar: "",
    desc: "فعال‌سازی چالش‌های کوکی، JavaScript و CAPTCHA برای هر URL به‌صورت جداگانه؛ مقابله هوشمندانه با بات‌ها و حملات هدفمند",
  },
];

const serviceFeatures = [
  {
    title: "تحویل سریع محتوا با کمترین تاخیر",
    desc: "با بهره‌مندی از گستره‌ای از پاپ‌سایت‌های داخلی و بین‌المللی در نقاط جغرافیایی متنوع",
    logo: "Feature-1.svg",
    imgAlt: "تحویل سریع محتوا با کمترین تاخیر",
    imgTitle: "تحویل سریع محتوا با کمترین تاخیر",
  },
  {
    title: "افزایش پایداری و دسترس‌پذیری محتوا",
    desc: "دسترسی دائمی به محتوا حتی در صورت از دسترس خارج شدن موقتی سرور",
    logo: "Feature-5.svg",
    imgAlt: "افزایش پایداری و دسترس‌پذیری محتوا",
    imgTitle: "افزایش پایداری و دسترس‌پذیری محتوا",
  },
  {
    title: "مصون از تهدیدات سایبری پیشرفته",
    desc: "محافظت در مقابل انواع تهدیدات و حملات سایبری از جمله DDoS لایه ۳، ۴ و ۷",
    logo: "Feature-6.svg",
    imgAlt: "مصون از تهدیدات سایبری پیشرفته",
    imgTitle: "مصون از تهدیدات سایبری پیشرفته",
  },
  {
    title: "کاهش مصرف منابع و آزادسازی پهنای باند",
    desc: "با فشرده‌سازی هوشمند و کوچک‌سازی فایل‌ها و کاهش تبادل با سرور",
    logo: "Feature-3.svg",
    imgAlt: "کاهش مصرف منابع و آزادسازی پهنای باند",
    imgTitle: "کاهش مصرف منابع و آزادسازی پهنای باند",
  },
  {
    title: "هدایت هوشمند ترافیک میان سرورها",
    desc: "توزیع ترافیک با لودبالانسر DNS و HTTP بر اساس توان زیرساخت سازمان شما",
    logo: "Feature-2.svg",
    imgAlt: "هدایت هوشمند ترافیک میان سرورها",
    imgTitle: "هدایت هوشمند ترافیک میان سرورها",
  },
  {
    title: "فایروال و WAF یکپارچه با CDN",
    desc: "حفاظت پیشرفته از زیرساخت ابری در برابر تهدیدات، بدون نیاز به سخت‌افزار",
    logo: "Feature-7.svg",
    imgAlt: "فایروال و WAF یکپارچه با CDN",
    imgTitle: "فایروال و WAF یکپارچه با CDN",
  },
  {
    title: "DNS ابری سریع با NS اختصاصی",
    desc: "مدیریت دامنه‌ها با DNS همیشه در دسترس و امکان تعریف NS دلخواه سازمانی",
    logo: "Feature-8.svg",
    imgAlt: "DNS ابری سریع با NS اختصاصی",
    imgTitle: "DNS ابری سریع با NS اختصاصی",
  },
  {
    title: "فعال‌سازی خودکار SSL رایگان",
    desc: "امن‌سازی ارتباط کاربران و افزایش اعتبار وب‌سایت با گواهی SSL/TLS رایگان",
    logo: "Feature-4.svg",
    imgAlt: "فعال‌سازی خودکار SSL رایگان",
    imgTitle: "فعال‌سازی خودکار SSL رایگان",
  },
];

export default {
  tabItems,
  logos,
  customers,
  dataBlog,
  questions,
  solotionTabItems,
  PopularServices,
  scrubbingCenter,
  cdnCoverage,
  serviceFeatures,
};
